import React, { useReducer } from 'react';

import { ColumnDropdownProps } from './ColumnDropdown.types';
import CheckboxSelectField from 'FRONTEND/components/CheckboxSelectField/CheckboxSelectField';
import { CheckboxSelectFieldOption } from 'FRONTEND/components/CheckboxSelectField/CheckboxSelectField.types';
import i18n from 'FRONTEND/utils/i18n';


/**
* @deprecated - Was used for old datatables system, no longer needed.
*/
const ColumnDropdown = ({
  datatable,
}: ColumnDropdownProps) => {
  const [, updateList] = useReducer(x => x + 1, 0);

  const options: CheckboxSelectFieldOption[] = datatable?.columnsSettings.filter(c => c.label).map(({ label, name }) => ({
    value: name,
    label,
  }));

  const selectedValues = datatable?.columnsSettings
    .filter(c => c.label)
    .map(({ name }) => {
      const column = datatable.column(`${name}:name`);
      return column.visible() ? name : null;
    })
    .filter(Boolean) || [];

  const handleChange = (newSelectedValues) => {
    datatable?.columnsSettings.filter(c => c.label).forEach(({ name }) => {
      const column = datatable.column(`${name}:name`);
      const shouldBeVisible = newSelectedValues.includes(name);

      if (column.visible() !== shouldBeVisible) {
        column.visible(shouldBeVisible);
      }
    });
    datatable?.columns.adjust();
    datatable?.state.save();
    updateList();
  };

  if (datatable) {
    return (
      <CheckboxSelectField
        options={options}
        selectedValues={selectedValues}
        onChange={handleChange}
        placeholder={i18n._('Columns')}
        showSelectAll={false}
        sx={{ ml: 2 }}
      />
    );
  }
};

export default ColumnDropdown;
